import React from "react";
import Card from 'react-bootstrap/Card';
import DnsDiagram from '../../../assets/images/diagram-DNS.png';
import DnsDiagram2 from '../../../assets/images/diagramDNS.png';

import './styles.css';
import PortChecker from "../components/PortChecker";

const DNS = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">                    
                    <Card className="card">
                        <Card.Title><h1>DNS - Domain Name Server</h1></Card.Title>
                        <Card.Body>
                            <div>
                                <span>
                                    Imagine que você tem um roteador conectado à internet e uma rede local com vários dispositivos. Cada dispositivo possui um endereço IP interno único na rede, como 192.168.10.150, 192.168.10.10, 192.168.10.95 etc.
                                    
                                    Quando uma solicitação de conexão chega ao seu roteador(ONU) pela internet, ela contém um endereço IP de origem e um número de porta. Vamos supor que alguém esteja tentando acessar o seu servidor web a partir de fora da sua rede local. Essa pessoa envia uma solicitação ao endereço IP público do seu roteador na porta 80, que é a porta padrão para conexões HTTP.
                                </span>
                            </div>
                            <div className='image'><img src={DnsDiagram2} alt="Foto" />                              
                            </div>
                            <div>                                
                            <span>
                                Esse processo permite que você acesse serviços ou dispositivos internos de sua rede local a partir da internet. O roteador atua como um intermediário, direcionando as solicitações externas para os dispositivos corretos dentro da sua rede.
                            </span>
                            </div>
                            
                            <PortChecker />
                        </Card.Body>
                    </Card>
                    
                </div>
            </div>
        </div>
    )
};
export default DNS;